<script setup lang="ts">
    import ModalBase from '@/shared/components/ModalBase.vue';
    import { PolicySystem } from '@/shared/helpers/api.ts';
    import { computed, ref, Ref } from 'vue';

    const emits = defineEmits<{
        onCancel: [void];
        onSave: [value: PolicySystem];
    }>();

    const systemName: Ref<string | undefined> = ref(undefined);
    const description: Ref<string | undefined> = ref(undefined);

    const isFormValid = computed(() => {
        if (systemName.value !== undefined) {
            return systemName.value.trim().length > 0;
        }
        return false;
    });

    const onCancel = () => emits('onCancel');

    function onClickSubmit() {
        if (systemName.value !== undefined) {
            const newPolicySystem: PolicySystem = {
                name: systemName.value,
                description: description.value ?? '',
                roles: []
            };
            emits('onSave', newPolicySystem);
        }
    }
</script>

<template>
    <modal-base @onCancel="onCancel">
        <template
            #modal-header>
            Add System
        </template>
        <template
            #modal-body>
            <section>
                <b-field
                    horizontal
                    label="Name">
                    <b-input
                        v-model="systemName" />
                </b-field>
                <b-field
                    horizontal
                    label="Description">
                    <b-input
                        v-model="description" />
                </b-field>
            </section>
        </template>
        <template #modal-footer>
            <b-field
                grouped
                position="right">
                <b-button
                    label="Cancel"
                    @click="onCancel" />
                <b-button
                    label="Add"
                    type="is-primary"
                    :disabled="!isFormValid"
                    @click="onClickSubmit" />
            </b-field>
        </template>
    </modal-base>
</template>

<style scoped>

</style>
